import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import TimeCounter from '../../../ui-core/TimeCounter';
import useWindowWidth from '../../../hooks/useWindowWidth';
import { TEXT_CONSTANT } from '../../../constants/app';
import { getDisplayType } from '../../../utils/helpers';
import Button from '../../../ui-core/Button/Button';

import './style.css';

const Label = props => {
  const displayType = getDisplayType(useWindowWidth());
  const isMobileScreen = displayType === 'mobile';
  const title = isMobileScreen
    ? TEXT_CONSTANT.GRATEFUL_CHALLENGE
    : TEXT_CONSTANT.REGISTER_NOW;
  const timerLabel =
    isMobileScreen || new Date() > new Date(props.endDate)
      ? ''
      : ' The challenge begins in:';

  const handleClick = () => {
    if (props.onClick) {
      props.onClick(TEXT_CONSTANT.JOIN_NOW, 'isSignup', title);
    }
  };

  return (
    <div
      className={clsx('label-wrapper', isMobileScreen && 'flex-column py-2')}
    >
      <div className="me-1 challenge-label-text">{title + timerLabel}</div>
      <div className="timer-block">
        {props?.liveNow && <TimeCounter endDate={props.endDate} />}
        <Button
          class={'join-now-button'}
          text={TEXT_CONSTANT.JOIN_NOW}
          onClick={handleClick}
        />
      </div>
    </div>
  );
};

Label.propTypes = {
  endDate: PropTypes.string,
  onClick: PropTypes.func,
  liveNow: PropTypes.bool,
};

export default Label;
